import createReducer from '../../config/create_reducer';
import Const from '../../const';

const defaultState = {
  advisors: null,
  advisorsLoaded: null
};

const handler = {
  [Const.wizard.advisorSelection.advisorsLoaded]: (state, { advisorsPage }) => ({
    ...state,
    ...advisorsPage,
    advisorsLoaded: advisorsPage.advisors.length === 0 ? false : new Date().getTime()
  }),
  [Const.wizard.advisorSelection.emailExists]: (state, { email }) => ({
    ...state,
    emailExistsError: email ? new Date().getTime() : null,
    emailExists: email
  })
};

export default createReducer(defaultState, handler);
